
define('app/common/setup',[
	'jquery',
	'underscore',
	
	//Shims
	'jquery.uniform'
], function($, _){
	var initialize = function(){
		// Avoid `console` errors in browsers that lack a console.
		(function() {
		    var method;
		    var noop = function () {};
		    var methods = [
		        'assert', 'clear', 'count', 'debug', 'dir', 'dirxml', 'error',
		        'exception', 'group', 'groupCollapsed', 'groupEnd', 'info', 'log',
		        'markTimeline', 'profile', 'profileEnd', 'table', 'time', 'timeEnd',
		        'timeStamp', 'trace', 'warn'
		    ];
		    var length = methods.length;
		    var console = (window.console = window.console || {});

		    while (length--) {
		        method = methods[length];

		        // Only stub undefined methods.
		        if (!console[method]) {
		            console[method] = noop;
		        }
		    }
		}());
		
		//Mustache style templates
		_.templateSettings = {
		  interpolate : /\{\{(.+?)\}\}/g
		};

		//Convenience function for parameter retrieval
		//DEPRECIATED - use jquery.getUrlParam.js instead
		$.urlParam = function getUrlVar(key){
			var result = new RegExp(key + "=([^&]*)", "i").exec(window.location.search); 
			return result[1] || null; 
		};
		
		$.isLocalStorageSaveSupported = function isLocalStorageSaveSupported(){
			var testKey = 'test', storage = window.sessionStorage;
			try {
		    	storage.setItem(testKey, '1');
		        storage.removeItem(testKey);
		        return true;
		    } catch (error) {
		    	return false;
		    }
		};
	};
	
	return {
		initialize: initialize
	};
});
